// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"179":"main","328":"admin","378":"user","501":"public"}[chunkId] || chunkId) + "." + {"179":"60d84008","328":"3a42748d","378":"b7930ef8","501":"82441a11","830":"8c16423f"}[chunkId] + ".css";
};